import Page from "~/components/pages/page";
import type { Route } from "./+types/home";
import { loader as splatLoader, meta as splatMeta } from "./products/splat";

export const loader = splatLoader;
export const meta = splatMeta;

export default function Index({ loaderData }: Route.ComponentProps) {
	const { shape } = loaderData;
	if (shape === "landing-page") {
		return <Page data={loaderData} />;
	}
}
